"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.classifyPercentage = exports.classifyAvailability = void 0;
const TDR_1 = __importDefault(require("../types/TDR"));
const classifyAvailability = (dayAvailability) => {
    if (!dayAvailability || dayAvailability.status === 'closed') {
        return 'closed';
    }
    if (dayAvailability.total === 0) {
        return 'none';
    }
    const percentage = dayAvailability.available / dayAvailability.total;
    if (percentage === 0) {
        return 'none';
    }
    if (percentage > TDR_1.default.Availability.LIMITED) {
        return 'high';
    }
    return 'limited';
};
exports.classifyAvailability = classifyAvailability;
const classifyPercentage = (percentage, isMonth) => {
    if (percentage === 0) {
        return 'none';
    }
    if (percentage > (!!isMonth ? TDR_1.default.Availability.MONTH_LIMITED : TDR_1.default.Availability.LIMITED)) {
        return 'high';
    }
    return 'limited';
};
exports.classifyPercentage = classifyPercentage;
//# sourceMappingURL=availability.js.map